import RadioSelector from 'components/radioSelector/RadioSelector';
import { Collapse } from 'plataforma-fundacao-componentes';
import { useEffect, useState } from 'react';
import { languageValues } from 'utils/LanguageUtils';
import { BuscarAgenciaPorCep } from './buscarAgenciaPorCep/BuscarAgenciaPorCep';
import { SelecionarCooperativaAgencia } from './selecionarCooperativaAgencia/SelecionarCooperativaAgencia';
enum TipoSelecaoAgencia {
  INFORMAR = 'informar',
  LOCALIZAR = 'localizar',
}

const texts = languageValues.pages.naoAssociado;

type Props = {
  selecionarAgencia: (value?: string) => void;
  selecionarCooperativa: (value?: string) => void;
};

export default function EventoSistemicoForm({
  selecionarAgencia,
  selecionarCooperativa,
}: Props) {
  const [tipoSelecaoAgencia, setTipoSelecaoAgencia] =
    useState<TipoSelecaoAgencia>(TipoSelecaoAgencia.INFORMAR);

  // Limpa a agencia e a cooperativa ao mudar o tipo de seleção
  useEffect(() => {
    selecionarAgencia(undefined);
    selecionarCooperativa(undefined);
  }, [selecionarAgencia, selecionarCooperativa, tipoSelecaoAgencia]);

  return (
    <>
      <RadioSelector
        setValue={setTipoSelecaoAgencia}
        value={tipoSelecaoAgencia}
        options={[
          {
            label: texts.eventoSistemico.radio.informarLabel,
            value: TipoSelecaoAgencia.INFORMAR,
          },
          {
            label: texts.eventoSistemico.radio.localizarLabel,
            value: TipoSelecaoAgencia.LOCALIZAR,
          },
        ]}
        label={texts.eventoSistemico.radio.title}
      />

      <Collapse
        animateOpacity
        opened={tipoSelecaoAgencia === TipoSelecaoAgencia.INFORMAR}
      >
        <SelecionarCooperativaAgencia
          selecionarAgencia={selecionarAgencia}
          selecionarCooperativa={selecionarCooperativa}
        />
      </Collapse>
      <Collapse
        animateOpacity
        opened={tipoSelecaoAgencia === TipoSelecaoAgencia.LOCALIZAR}
      >
        <BuscarAgenciaPorCep
          selecionarAgencia={selecionarAgencia}
          selecionarCooperativa={selecionarCooperativa}
        />
      </Collapse>
    </>
  );
}
